import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={59} height={81} viewBox="0 0 59 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M29.5.75c14.665 0 26.26 8.613 26.26 21.654 0 6.219-2.505 11.382-6.407 15.2 5.559 4.03 8.897 10.38 8.897 17.976 0 14.78-12.494 24.67-28.75 24.67C13.138 80.25.75 70.358.75 55.58c0-7.596 3.337-13.946 8.896-17.975-3.901-3.819-6.407-8.982-6.407-15.2C3.24 9.364 14.73.75 29.5.75zm0 44.556c-3.095 0-5.543 1.032-7.214 2.672-1.672 1.64-2.614 3.938-2.614 6.562 0 2.783.97 5.074 2.645 6.672 1.679 1.6 4.127 2.562 7.183 2.562 3.001 0 5.452-.96 7.145-2.564 1.691-1.6 2.683-3.893 2.683-6.67 0-2.624-.942-4.921-2.614-6.563-1.671-1.64-4.12-2.671-7.214-2.671zm0-28.704c-4.853 0-8.48 3.174-8.48 7.674 0 4.506 3.53 7.674 8.48 7.674 2.482 0 4.575-.804 6.04-2.143 1.46-1.335 2.336-3.237 2.336-5.53 0-4.506-3.633-7.675-8.376-7.675z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
